import React, { Component } from "react";
import { Form, Button, Select,Icon, Tooltip,Input,Divider,Radio } from "antd";
import { connect } from "react-redux";
import * as loginActions from "../../actions";
import "./step2.css";

const { Option } = Select;

class StepTwo extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  checkPhoneNumberLength = (rule, value, callback) => {
    if (value && value.length !== 10) {
      callback("Phone Nmuber must be 10 Digits");
    } else {
      callback();
    }
  };

  render() {
    const { form, profile } = this.props;
    const { getFieldDecorator, validateFields } = form;
    const { semester,gradYear, branch, section, campus,rollnumber,role,cgpa,sgpa,backlogs,tenthgpa,intergpa,backlogshistory,designation } = profile;
    const onValidateForm = e => {
      e.preventDefault();
      validateFields((err, values) => {
      
       
        if (!err) {
          // 
          this.props.stepTwoSubmit(values);
        }
      });
      // this.props.login({});
    };

    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 6 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 8 }
      }
    };

    return (
      <>
        <h2 className="steponeHeading">Academic Details</h2>
        <p className="steponeDisc">Please add your academic details</p>
        <Form {...formItemLayout}>
          <Form.Item label="Campus" className="formsteponeinout">
            {getFieldDecorator("campus", {
              initialValue: campus,
              rules: [{ required: true, message: "Please select your campus" }]
            })(
              <Select placeholder="Please select your campus" disabled>
                <Option value="BVRIT">BVRIT</Option>
                <Option value="BVRITH">BVRITH</Option>
                <Option value="VIT">VIT</Option>
                <Option value="SVECW">SVECW</Option>
              </Select>
            )}
          </Form.Item>

          <Form.Item label="Department" className="formsteponeinout">
            {getFieldDecorator("branch", {
              initialValue: branch,
              rules: [{ required: true, message: "Please select your branch" }]
            })(
              <Select placeholder="Please select your branch">
                <Option value="ECE">ECE</Option>
                <Option value="CSE">CSE</Option>
                <Option value="MECH">MECH</Option>
                <Option value="EEE">EEE</Option>
                <Option value="EIE">EIE</Option>
                <Option value="IT">IT</Option>
                <Option value="C&IT">C&IT</Option>
                <Option value="CIVIL">CIVIL</Option>
                <Option value="MCA">MCA</Option>
                <Option value="BCA">BCA</Option>
                <Option value="MBA">MBA</Option>
                <Option value="Mathematics">Mathematics</Option>
                <Option value="Physics">Physics</Option>
                <Option value="Chemistry">Chemistry</Option>
                <Option value="BasicScience">Basic science</Option>
                <Option value="Other">Other</Option>
              </Select>
            )}
          </Form.Item>

          
          {role && role !='STUDENT' && <>  <Form.Item
            hasFeedback
            className="formsteponeinout"
            label={
              <span>
                Designation&nbsp;
                <Tooltip title="Select Your Designation">
                  <Icon type="question-circle-o" />
                </Tooltip>
              </span>
            }
          >
            {getFieldDecorator("designation", {
              initialValue: designation,
              rules: [
                { required: true, message: "Please select your designation" }
              ]
            })(
              <Select placeholder="Please select your designation">
                
                <Option value="Principal">Principal</Option> 
                <Option value="Vice Principal">Vice Principal</Option>
              <Option value="Assistant Professor">Assistant Professor</Option>
              <Option value="Associate Professor">Associate Professor</Option>
              <Option value="Professor">Professor</Option>
              <Option value="Head of Department (HOD)">Head of Department (HOD)</Option>
              <Option value="Other">Other</Option>
            </Select>
            )}
          </Form.Item> </>}

{role && role =='STUDENT' && <>  <Form.Item label="Year of Graduation" className="formsteponeinout">
            {getFieldDecorator("gradYear", {
              initialValue: gradYear,
              rules: [
                { required: true, message: "Please select your graduation year" }
              ]
            })(
              <Select placeholder="Please select your graduation year">
                <Option value="2019">2019</Option>
                <Option value="2020">2020</Option>
                <Option value="2021">2021</Option>
                <Option value="2022">2022</Option>
                <Option value="2023">2023</Option>
                <Option value="2024">2024</Option>
              </Select>
            )}
          </Form.Item>
          <Form.Item label="Section" className="formsteponeinout">
            {getFieldDecorator("section", {
              initialValue: section,
              rules: [{ required: true, message: "Please select your section" }]
            })(
              <Select placeholder="Please select your section">
                <Option value="A">A</Option>
                <Option value="B">B</Option>
                <Option value="C">C</Option>
                <Option value="D">D</Option>
                <Option value="E">E</Option>
                <Option value="F">F</Option>
                <Option value="G">G</Option>
                <Option value="H">H</Option>
                <Option value="I">I</Option>
                <Option value="J">J</Option>
                <Option value="K">K</Option>
                <Option value="L">L</Option>
              </Select>
            )}
          </Form.Item>
          <Form.Item
            hasFeedback
            className="formsteponeinout"
            label={
              <span>
               College Roll Number&nbsp;
                <Tooltip title="Your Roll Number (As per college records). If you don't have. Keep NA">
                  <Icon type="question-circle-o" />
                </Tooltip>
              </span>
            }
          >
            {getFieldDecorator("rollnumber", {
              initialValue: rollnumber,
              rules: [
                { required: true, message: "Please input your Roll Number" }
              ]
            })(
              <Input
                prefix={
                  <Icon type="contacts" style={{ color: "rgba(0,0,0,.25)" }} />
                }
                type="text"
                placeholder="Roll Number"
                size="large"
              />
            )}
          </Form.Item>

          <Divider orientation="left">Acadamic Performance</Divider>
          <Form.Item
            hasFeedback
            className="formsteponeinout"
            label={
              <span>
                Your Current SGPA&nbsp;
                <Tooltip title="Your Current SGPA. If you don't have. Keep NA">
                  <Icon type="question-circle-o" />
                </Tooltip>
              </span>
            }
          >
            {getFieldDecorator("sgpa", {
              initialValue: sgpa,
              rules: [
                { required: true, message: "Please input your current semester SGPA.If you don't have. Keep NA" }
              ]
            })(
              <Input
              
                type="text"
                placeholder="SGPA"
               
              />
            )}
          </Form.Item>

          <Form.Item
            hasFeedback
            className="formsteponeinout"
            label={
              <span>
                Your Current CGPA&nbsp;
                <Tooltip title="Your Current CGPA. If you don't have. Keep NA">
                  <Icon type="question-circle-o" />
                </Tooltip>
              </span>
            }
          >
            {getFieldDecorator("cgpa", {
              initialValue: cgpa,
              rules: [
                { required: true, message: "Please input your current CGPA. If you don't have. Keep NA" }
              ]
            })(
              <Input
                type="text"
                placeholder="CGPA"
              
              />
            )}
          </Form.Item>

          <Form.Item
            hasFeedback
            className="formsteponeinout"
            label={
              <span>
               Current Number of Backlogs&nbsp;
                <Tooltip title="Your Current Number of Backlogs. If you don't have. Keep 0">
                  <Icon type="question-circle-o" />
                </Tooltip>
              </span>
            }
          >
            {getFieldDecorator("backlogs", {
              initialValue: backlogs ? backlogs :0,
              rules: [
                { required: true, message: "Please input your current number of backlogs" }
              ]
            })(
              <Input
                type="number"
                placeholder="If no backlogs. Keep 0"
               
              />
            )}
          </Form.Item>

          <Form.Item label={<span>
             Backlogs History&nbsp; 
                <Tooltip title="Do you have any Backlogs History?">
                  <Icon type="question-circle-o" />
                </Tooltip>
              </span>} className="formsteponeinout">
            {getFieldDecorator("backlogshistory", {
              initialValue: backlogshistory,
              rules: [{ required: true, message: "Do you have any Backlogs History?" }]
            })(
              <Radio.Group>
                <Radio value="NO">NO</Radio>
                <Radio value="YES">YES</Radio>
              </Radio.Group>
            )}
          </Form.Item>

          <Divider orientation="left">10th & 12th Performance</Divider>
          <Form.Item
            hasFeedback
            className="formsteponeinout"
            label={
              <span>
                10th Marks&nbsp;
                <Tooltip title="Your Tenth Class CGPA/Percentage. If you don't have. Keep NA">
                  <Icon type="question-circle-o" />
                </Tooltip>
              </span>
            }
          >
            {getFieldDecorator("tenthgpa", {
              initialValue: tenthgpa,
              rules: [
                { required: true, message: "Your Tenth Class CGPA/Percentage. If you don't have. Keep NA" }
              ]
            })(
              <Input
              addonBefore={<Select defaultValue="CGPA" >
              <Option value="CGPA">CGPA</Option>
              <Option value="Percentage">Percentage</Option>
            </Select>}
                type="text"
                placeholder="CGPA or Percentage"
              />
            )}
          </Form.Item>

          <Form.Item
            hasFeedback
            className="formsteponeinout"
            label={
              <span>
                12th Marks&nbsp;
                <Tooltip title="Your 12th Class CGPA/Percentage. If you don't have. Keep NA">
                  <Icon type="question-circle-o" />
                </Tooltip>
              </span>
            }
          >
            {getFieldDecorator("intergpa", {
              initialValue: intergpa,
              rules: [
                { required: true, message: "Please input your current CGPA. If you don't have. Keep NA" }
              ]
            })(
              <Input
              addonBefore={<Select defaultValue="CGPA" >
              <Option value="CGPA">CGPA</Option>
              <Option value="Percentage">Percentage</Option>
            </Select>}
                type="text"
                placeholder="CGPA or Percentage"
              />
            )}
          </Form.Item>

          </>}
         
          <Form.Item>
            <Button type="primary" onClick={onValidateForm} htmlType="submit">
              Next
            </Button>
          </Form.Item>
        </Form>
      </>
    );
  }
}

const mapStateToProps = state => {
  // 
  // 
  return {
    auth: state.firebase.auth,
    step: state.auth.step,
    profile: state.firebase.profile
  };
};

const mapDispachToProps = (dispatch, props) => ({
  stepTwoSubmit: formValue => {
    dispatch(loginActions.stepTwoSubmit(formValue, props.history));
  }
});

export default connect(
  mapStateToProps,
  mapDispachToProps
)(Form.create()(StepTwo));
